$(function(){
/*==============================================================================
ページ遷移時の状態取得

navigate：リンクをクリックするか、ブラウザのアドレスバーにURLを入力するか、フォームを送信するか、以下のreloadとback_forward以外のスクリプト操作で初期化した場合
reload：ブラウザのリロード操作またはlocation.reload()が行われた場合
back_forward：ブラウザのヒストリーバックまたはヒストリーフォワード操作をした場合
prerender：事前レンダリングによって初期化された場合

entries[0].type==='back_forward'
==============================================================================*/
// var entries=window.performance.getEntriesByType("navigation");
// window.addEventListener("pageshow",function(event){
// 	var entries=performance.getEntriesByType("navigation");
// 	entries.forEach(function(entry){
// 		if(entry.type=='back_forward'){
// 			$('body').removeClass('nav-'+navContents.active);
// 		}
// 	});
// });
/*==============================================================================
matchHeight
==============================================================================*/
if($('body').hasClass('home')){
	$('#about section>div p:not(.link_btn)').matchHeight();
}
/*==============================================================================
pagetop
==============================================================================*/
//.pagetopがクリックされたら上へ戻る
$('#pagetopBtn').children('a').click(function(){
	$("html,body").animate({
		scrollTop:0
	},800);
	return false;
});
/*==============================================================================
スクロール値を使用したアニメーション処理
==============================================================================*/
var scrollValue={
	top:null,
	currentPosition:0
}
function scrollAnimation(){
	//========== load時 ==========
	scrollValue.top=$(window).scrollTop();

	//header背景
	if($('body').hasClass('home')){
		if(scrollValue.top>150){
			$('header').addClass('on');
		}else{
			$('header').removeClass('on');
		}
	}

	//現在のスクロール値
	scrollValue.currentPosition=scrollValue.top;

	//========== scroll時 ==========
	$(window).on('scroll',function(){
		scrollValue.top=$(this).scrollTop();

		//下スクロールされた場合
		// if(scrollValue.top>300 && scrollValue.top<scrollValue.currentPosition){
		// 	$('body').addClass('scrolled');
		// }else{
		// 	$('body').removeClass('scrolled');
		// }

		//header背景
		if($('body').hasClass('home')){
			if(scrollValue.top>150){
				$('header').addClass('on');
			}else{
				if(!$('body').hasClass('nav-active') && ($('#navigation').is('[data-tab-nav-type="slideRight"]') || $('#navigation').is('[data-pc-nav-type="slideRight"]') || $('#navigation').is('[data-tab-nav-type="slideLeft"]') || $('#navigation').is('[data-pc-nav-type="slideLeft"]'))){
					$('header').removeClass('on');
				}
			}
		}

		//pagetop
		if(scrollValue.top>300){
			$('#pagetop').addClass('show');
		}else{
			$('#pagetop').removeClass('show');
		}

		//現在のスクロール値
		scrollValue.currentPosition=scrollValue.top;
	});
}
scrollAnimation();

/*==============================================================================
ナビゲーション処理
==============================================================================*/
let navContents={
	btn:'#nav_btn',
	cnt:'#navigation',
	active:'active'
}
$(navContents.btn).click(function(){
	//nav
	$('body').toggleClass('nav-'+navContents.active);
	$(navContents.btn).toggleClass(navContents.active);
	$(navContents.cnt).toggleClass(navContents.active);
	//$(navContents.cnt).toggleClass(navContents.active).fadeToggle();

	return false;
});
//========== ナビゲーション .active削除 ==========
function navActive(deviceFlag,navContents){
	$(navContents.cnt+' a,main').on('click',function(){
		$('body').removeClass('nav-'+navContents.active);
		$(navContents.btn).removeClass(navContents.active);
		$(navContents.cnt).removeClass(navContents.active);
		//$(navContents.cnt).removeClass(navContents.active).fadeOut();
	});

	// if(deviceFlag!='mobile'){
		
	// }else{
		
	// }
}
/*==============================================================================
drawer
==============================================================================
let drawerContents={
	btn:'.drawer_btn>a',
	cnt:'.drawer_cnt',
	active:'drawer_active'
}
$(drawerContents.btn).click(function(){
	$(drawerContents.btn).toggleClass(drawerContents.active);
	$(drawerContents.cnt).slideToggle();
	return false;
});*/
/*==============================================================================
accordion
==============================================================================*/
let accordionContents={
	baseClass:'.accordion',
	btn:'.accordion_btn',
	cnt:'.accordion_cnt',
	active:'open'
}
$(accordionContents.btn).click(function(){
	$(this).toggleClass(accordionContents.active);
	$(this).next(accordionContents.cnt).slideToggle();
	//$(this).parents(accordionContents.baseClass).find(accordionContents.cnt).slideToggle();
	return false;
});
/*==============================================================================
scroll-hint (table)
==============================================================================*/
if($('.scroll-hint').length){
	new ScrollHint('.scroll-hint',{
		suggestiveShadow:true,
		remainingTime:5000,
		i18n:{
			scrollable:'スクロールできます'
		}
	});
}
/*==============================================================================
InfiniteScroll
==============================================================================
if($('body').hasClass('archive')){
	var infScroll=new InfiniteScroll('.list_cnt',{ //大枠のセレクタ
		append:'.list_post', //読み込むボックスたちのセレクタ
		path:'.pagination .next', //次ページへ飛ぶための「次へ」ボタンのセレクタ
		hideNav:'.pagination', //ページネーションのセレクタ
		button:'.btn_more', //「もっと見る」ボタンのセレクタ
		scrollThreshold:false, //自動で次のページを読み込まないようにする
		status:'.scroller-status', // ステータスのセレクタ
		history:'false', //読み込み後のURLを変更しない
	});
}*/
/*==============================================================================
アンカーリンク
==============================================================================*/
let anchorLink={
	headerHeight:document.getElementsByTagName('header')[0].clientHeight,
	// headerHeight:80,
	offset:20,
	speed:600
}

//========== ページ内スムーススクロール ==========
function smoothScroll(anchorLink){
	//$('a[href^="#"]').on('click',function(){
	$('a[href*="#"]').on('click',function(){
		var href=$(this).attr('href');
		if(href.slice(0,1)!='#'){
			href=href.substring(href.indexOf("#"));
		}
		var target=$(href=='#' || href=='' ? 'html':href);
		var position=target.offset().top;
		$('body,html').animate({
			scrollTop:(position-anchorLink.headerHeight)-anchorLink.offset
		},anchorLink.speed,'swing');
		return false;
	});
}
smoothScroll(anchorLink);

//==========　ページ遷移後位置をずらす処理　==========
function hashPageTransition(anchorLink){
	var hash=window.location.hash;
	if(hash && $(hash).length){
		var position=$(hash).offset().top;
		$('html,body').animate({
			scrollTop:(position-anchorLink.headerHeight)-anchorLink.offset
		},0);
	}
}
hashPageTransition(anchorLink);

/*==============================================================================
スクロールアニメーション処理
==============================================================================*/
function intersectionObserver(bool){
	var observer=null;
	if(bool){
		//===== オプション =====
		var options={
			//root:null, //交差の基準となる親要素を指定(初期値はdocument)
			rootMargin: '0px 0px -10% 0px' //下端から10%入ったところで発火
			//threshold: [0, 0.5, 1.0] //要素を検出したいratioを0-1の間で指定が可能(初期値は0,1のみ)
		}
		//===== 交差を検出した際に呼ばれるコールバック =====
		var callback=function(entries,observer){
			Array.prototype.forEach.call(entries,function(e){ //IE11対策用
			//entries.forEach(function(e){
				//console.log(e);
				//===== 交差した時の処理 =====
				if(e.isIntersecting){
					//class or data属性追加
					//e.target.setAttribute('data-animation','on'); //IE11対策用
					//e.target.dataset.animation='on'; //data属性で入力する場合
					e.target.classList.add('move'); // classで入力する場合

					//カウントアップ処理発火
					/*if(e.target.classList.contains('countup')){
						countUp(e.target.innerText,e.target.dataset.count,2000,'swing',$(e.target));
					}*/

					//指定した要素のobserveを解除する
					observer.unobserve(e.target);
				}else{
					return;
				}
			})
		}
		observer=new IntersectionObserver(callback,options);

		//===== 交差を検出したい要素を登録 =====
		//animation
		var target=document.querySelectorAll('.io'); //監視したい要素をNodeListで取得
		for(var i=0; i<target.length; i++){
			observer.observe(target[i]); //要素の監視を開始
		}
	}
	else{
		if(observer){observer.disconnect();} //登録されている全ての要素のobserveを解除する
	}
}
/*==============================================================================
初回ロード時の処理
==============================================================================
function firstTimeLoad(){
	$(window).on('load scroll',function(){
		if($(this).scrollTop()!=0){
			$('header').removeClass('firsttime');
		}
	});
}
firstTimeLoad();*/
/*==============================================================================
読み込み時・レスポンシブ時の処理
==============================================================================*/
//========== デバイスサイズ変数 ==========
let deviceWidth={
	tablet:600,
	desktop:860,
	flag:''
}
//========== ウインドウサイズ変数 ==========
let windowSize={
	w:null,
	h:null
}
function resizeDevice(){
	windowSize.w=$(window).width();

	//========== モバイル ==========
	if(windowSize.w<=deviceWidth.tablet && deviceWidth.flag!='mobile'){
		deviceWidth.flag='mobile';

		//スマホ時、リンクが2回タップしないと反応しないバグ対応（iOS google chrome）
		document.body.addEventListener('touchstart',function(){});

		//ナビゲーション
		navActive(deviceWidth.flag,navContents);

		//スクロールアニメーション
		intersectionObserver(true);

		//各ページ
		/*if($('body').hasClass('tax-city')){

		}*/
	}
	//========== タブレット ==========
	else if((windowSize.w>deviceWidth.tablet && windowSize.w<=deviceWidth.desktop) && deviceWidth.flag!='tablet'){
		deviceWidth.flag='tablet';

		//ナビゲーション
		navActive(deviceWidth.flag,navContents);

		//スクロールアニメーション
		intersectionObserver(true);

		//各ページ
		/*if($('body').hasClass('tax-city')){

		}*/
	}
	//========== デスクトップ ==========
	else if(windowSize.w>deviceWidth.desktop && deviceWidth.flag!='desktop'){
		deviceWidth.flag='desktop';

		//ナビゲーション
		navActive(deviceWidth.flag,navContents);

		//スクロールアニメーション
		intersectionObserver(true);
	}
}
resizeDevice();
$(window).on('resize',resizeDevice());

});